import styled, { css } from 'styled-components'
import { vars, mq } from '@snsw-gel/theming'

const flexProps = option => {
    if (option === 'start' || option === 'end') {
        return `flex-${option}`
    } else {
        return option
    }
}

export const RowStyled = styled.div`
    margin-left: 0;
    margin-right: 0;

    ${mq.min('tablet')} {
        display: flex;
        margin-left: calc(-1 * ${vars.grid.gutter} / 2);
        margin-right: calc(-1 * ${vars.grid.gutter} / 2);

        ${props =>
            props.alignItems &&
            css`
                align-items: ${flexProps(props.alignItems)};
            `}

        ${props =>
            props.justifyContent &&
            css`
                justify-content: ${flexProps(props.justifyContent)};
            `}
    }
`
